module.exports = __webpack_public_path__ + "img/hover_bg.3850f87b.png";